class BaseApplication {
  init() {}
  on_enter() {}
  update() {}
  on_post_render() {}
  on_post_start() {}
  dispose() {}

  check_resource_loading(batch, on_resources_loaded, timeout = 10) {
    if (batch.loading_finished) {
      if (batch.has_errors) {
        batch.print_errors();
      } else {
        on_resources_loaded();
      }
    } else {
      setTimeout(() => {
        this.check_resource_loading(batch, on_resources_loaded, timeout);
      }, timeout);
    }
  }
}

export { BaseApplication };
